import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordMatchValidator: (control: AbstractControl) => void = control => {
  const password: string = control.get('password')?.value;
  const confirmPassword: string = control.get('confirmPassword')?.value;
  if (password !== confirmPassword) {
    control.get('confirmPassword')?.setErrors({ NoPasswordMatch: true });
  } else {
    control.get('confirmPassword')?.setErrors(null);
  }
};

export const patternValidator: (regex: RegExp, error: ValidationErrors) => ValidatorFn = (regex, error) => {
  return (control: AbstractControl): Record<string, unknown> | null=> {
    if (!control.value) {
      return null;
    }

    const valid = regex.test(control.value);
    return valid ? null : error;
  };
};

export const fieldMatchValidator = (matchFieldName: string, equal: boolean = true): ValidatorFn => {
  return (control: AbstractControl) => {
    const matchValue: string = control.parent?.get(matchFieldName)?.value;
    const currentValue: string = control.value;

    if (!((matchValue === currentValue && equal) || (matchValue !== currentValue && !equal))) {
      return { fieldNoMatch: true }
    }

    return null;
  }
}
